import React from 'react';
import { PlusIcon, MinusIcon } from '@heroicons/react/24/outline';

function CompletionPercentage({ 
  completionPercent,
  updatingCompletion,
  completionError,
  handleCompletionChange
}) {
  return (
    <div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => handleCompletionChange(-5)}
          disabled={updatingCompletion || completionPercent <= 0}
          className={`p-1 rounded-full border border-gray-300 ${
            updatingCompletion || completionPercent <= 0 
              ? 'opacity-50 cursor-not-allowed' 
              : 'hover:bg-gray-100'
          }`}
          aria-label="Decrease completion by 5%"
        >
          <MinusIcon className="h-4 w-4 text-gray-500" />
        </button>
        
        <div className="flex-1 relative">
          <div className="w-full bg-gray-200 rounded-full h-4">
            <div 
              className="bg-indigo-600 h-4 rounded-full transition-all duration-200" 
              style={{ width: `${completionPercent}%` }}
            ></div>
          </div>
          {updatingCompletion && (
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-xs text-white font-medium animate-pulse">Updating...</span>
            </div>
          )}
        </div>
        
        <button
          onClick={() => handleCompletionChange(5)}
          disabled={updatingCompletion || completionPercent >= 100}
          className={`p-1 rounded-full border border-gray-300 ${
            updatingCompletion || completionPercent >= 100 
              ? 'opacity-50 cursor-not-allowed' 
              : 'hover:bg-gray-100'
          }`}
          aria-label="Increase completion by 5%"
        >
          <PlusIcon className="h-4 w-4 text-gray-500" />
        </button>
        
        <span className="whitespace-nowrap font-medium w-16 text-center">
          {completionPercent}%
        </span>
      </div>
      
      {completionError && (
        <p className="mt-2 text-xs text-red-500">
          {completionError}
        </p>
      )}
    </div>
  );
}

export default CompletionPercentage;